
/**
 * 試験日登録 アイコン
 */
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fill: {
      type: String,
      default: '#fff',
    },
  },
})
